import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { DateType } from 'shared/types';
import { useSwipe } from 'shared/hooks';

import { Store } from 'pages/calendar/store';

import { CalendarPageMonthDay } from './components/CalendarPageMonthDay';

import './styles.scss';
import classnames from 'classnames';

export const CalendarPageMonth = observer(function CalendarPageMonth() {
    const swipe = useSwipe({
        trackMouse: false,
        onSwipedLeft: Store.next,
        onSwipedRight: Store.prev,
    });

    useEffect(() => {
        const handler = (e: WheelEvent) => {
            if (!e.shiftKey || Store.view !== 'month') {
                return;
            }
            Store.set('date', Store.date.add(e.deltaY > 0 ? -1 : 1, 'month'));
        };

        window.addEventListener('wheel', handler);
        return () => {
            window.removeEventListener('wheel', handler);
        };
    }, []);

    const days = (() => {
        const days: DateType[] = [];
        let current = Store.date.startOf('month').startOf('week');
        const end = Store.date.endOf('month').endOf('week');

        while (current.isBefore(end)) {
            days.push(current);
            current = current.add(1, 'day');
        }

        return days;
    })();

    return (
        <div
            key={Store.date.format()}
            className={classnames('calendar-page-month', {
                'calendar-page-month--no-weekends': Store.filter.noWeekends,
            })}
            onWheelCapture={e => {
                if (Store.isLoading || e.deltaX === 0 || e.deltaY !== 0) {
                    return;
                }
                Store.set('date', Store.date.add(e.deltaX > 0 ? 1 : -1, 'month'));
            }}
            {...swipe}
        >
            <div className='calendar-page-month-header'>
                <div className='calendar-page-month-header__cell'>Пн</div>
                <div className='calendar-page-month-header__cell'>Вт</div>
                <div className='calendar-page-month-header__cell'>Ср</div>
                <div className='calendar-page-month-header__cell'>Чт</div>
                <div className='calendar-page-month-header__cell'>Пт</div>
                <div className='calendar-page-month-header__cell calendar-page-month-header__cell--weekend'>Сб</div>
                <div className='calendar-page-month-header__cell calendar-page-month-header__cell--weekend'>Вс</div>
            </div>
            <div className='calendar-page-month-days'>
                {days.map(day => {
                    return <CalendarPageMonthDay key={day.format('YYYY-MM-DD')} date={day} />;
                })}
            </div>
        </div>
    );
});
